import React, { useCallback, useState } from 'react';
import EditorGalleryEdit from '@wix/da-ds/pkg/Icons/24x24/EditorGalleryEdit';
import { ButtonProps } from '../../../../components/menus/buttons/types';
import GiphyPopup, { GifObject } from '../../../../components/lego/GiphyPopup';
import { useTranslation } from 'react-i18next';
import EditorIconButton from '../../../../components/menus/_partials/EditorIconButton';

const Edit: React.FC<ButtonProps> = ({ editor }) => {
  const { t } = useTranslation('editor');
  const [showGiphyPopup, setShowGiphyPopup] = useState<boolean>(false);
  const hideGiphyPopup = useCallback(() => {
    setShowGiphyPopup(false);
  }, [setShowGiphyPopup]);

  const onSelect = useCallback(
    (gif: GifObject) => {
      editor
        .chain()
        .focus()
        .daGifReplace({
          width: gif.width,
          height: gif.height,
          url: gif.originalMp4 ?? gif.originalUrl,
        })
        .run();
    },
    [editor]
  );

  return (
    <>
      {showGiphyPopup && (
        <GiphyPopup onClose={hideGiphyPopup} onSelect={onSelect} />
      )}
      <EditorIconButton
        featureId="node:gif:edit"
        icon={EditorGalleryEdit}
        onClick={() => setShowGiphyPopup(true)}
        tooltipText={t('ext.gif.button.edit')}
        aria-label={t('ext.gif.button.edit')}
      />
    </>
  );
};
Edit.displayName = 'Edit';

export default Edit;
